// in src/students.js
import React, { useEffect,useState, useCallback, Component } from 'react';
import { DateInput, FormDataConsumer, TopToolbar, ArrayInput, SimpleFormIterator, ArrayField, SingleFieldList, ChipField, List, Edit, Create, Datagrid, TextField, EditButton, LongTextInput, ReferenceInput, SelectInput, SimpleForm, TextInput, required, minLength, maxLength, minValue, maxValue, number, regex, email, choices, SelectField, AutocompleteInput } from 'react-admin';
import { RadioButtonGroupInput, useNotify, useRefresh, useRedirect, Filter, ListButton, CreateButton, ShowButton, DeleteButton, BulkDeleteButton } from 'react-admin';
import { Box, Typography, useMediaQuery } from '@material-ui/core';
import { useDataProvider } from 'react-admin';
import {validateEnrollmentDate} from './utils.js';



const validateName = [required(), minLength(2), maxLength(45)];
const validateEmail = [required(), email()];
const validatePIN = [required(), regex(/[0-9][0-9][0-9][0-9]/, "Must be 4 digit number")];
const validatePrg = [required()];
// const validateDate = [required(), regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateDate = [regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateDateOpt = [regex(/[0-9][0-9]\/[0-9][0-9]\/[0-9][0-9][0-9][0-9]/, "Must be valid date mm/dd/yyyy")];
const validateClass = [required()];
const validateSex = [required()];
const validateEStatus = [required()];
const validatePhone = [required(), regex(/[0-9][0-9][0-9]-[0-9][0-9][0-9]-[0-9][0-9][0-9][0-9]/), "Valid Phone number is required"];


var d = new Date();
var dt = d.getFullYear() + '-' + ('0' + (d.getMonth() + 1)).slice(-2) + '-'
    + ('0' + d.getDate()).slice(-2);


export const TourCreate = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    // const onSuccess = () => {
    //     notify(`Your tour request has been submitted`);
    //     redirect('http://lamsaz.com');
    //     refresh();
    // };

    const onSuccess = useCallback(
        (newRecord) => {
            // Show a success message
            notify('Record created successfully', 'success');

            // Redirect to another page (e.g., the list view)
            redirect('/tours/Complete/create');

            // You can also perform additional actions here
        },
        [notify, redirect]
    );

    const dataProvider = useDataProvider();
    const [TourDateTimes, setTourDateTimes] = useState([]);

    useEffect(() => {
        const fetchTourDateTimes = async () => {
            try {
                const fetchURL = process.env.REACT_APP_TOURDATES_URL
                const token = localStorage.getItem('token');
                const hdrs = new Headers({
                    "Content-Type": "application/json",
                    "Authorization": "Bearer " + token,
                })
                const params = new Object();
                const bdy = JSON.stringify(params);
                fetch(fetchURL, { method: 'GET', headers: hdrs })
                    .then(response => {
                        if (response.ok) {
                            response.json().then(json => {
                                if (json != "") {
                                    var dates = json.map((date, index) => {
                                        return {
                                            id: date, 
                                            name: date
                                        };
                                    });
                                    console.log(dates);
                                    setTourDateTimes(dates)
                                } else {
                                    
                                }
                            });
                        }
                    })
                    .catch((e) => {
                        console.error(e);
                        this.props.showNotification('Error: generating reports', 'warning')
                    });
  
            } catch (error) {
                console.error('Error fetching TourDateTimes:', error);
            }
        };

        fetchTourDateTimes();
    }, [dataProvider]);

    return (
        <Create onSuccess={onSuccess} {...props} >
            <SimpleForm>
                <Box p="1em">
                    <Box display="flex">
                        <Box >
                            <Typography variant="h6" gutterBottom>Tour Details</Typography>
                            <Box>
                                <Box display="flex">
                                    <TextInput label="Parent Name" source="ParentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <TextInput label="Student Name" source="StudentName" validate={required()}/>
                                </Box>
                                <Box>
                                    <SelectInput style={{ width: "250px" }} alwaysOn label="Program Applying For" source="Program" allowEmpty={false} choices={[
                                        { id: 'Toddler', name: 'Toddler (18 - 36 months)' },
                                        { id: 'Primary', name: 'Primary (3 - 6 years)' },
                                    ]} validate={required()} />
                                </Box>
                                <Box>
                                    <DateInput label="Enrollment Date" source="EnrollmentDate" validate={validateEnrollmentDate} />
                                </Box>
                                <Box>
                                    <TextInput label="Email" source="Email" validate={validateEmail}/>
                                </Box>
                                <Box>
                                    <TextInput label="Phone" source="Phone" validate={validatePhone}/>
                                </Box>
                                <Box>
                                    <SelectInput label="Available Dates & Time" source="DateTime" choices={TourDateTimes} optionText="name" optionValue="id" validate={required()}/>
                                </Box>

                            </Box>
                        </Box>
                    </Box>
                </Box>
            </SimpleForm>
        </Create >
    );
};


const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};


